import { useState } from "react";
import { TransmedReceivingDetailWithProblems } from "../../../../dtos/transmed/process/receivingDetail";
import TransmedProcessSlide from "./slide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faInfinity,
} from "@fortawesome/free-solid-svg-icons";
import { useSetError } from "../../../generic-error";
import { useRevalidator } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import InputDialog from "../../../../components/dialog";
import TransmedDistributionService from "../../../../service/transmed/process/distribution";
import TransmedReceiving from "../../../../dtos/transmed/process/receiving";
import TransmedRegistration from "../../../../dtos/transmed/process/registration/registration";

function TransmedProcessChosing(props: {
  registration: TransmedRegistration;
  details: TransmedReceivingDetailWithProblems[];
  receivings: TransmedReceiving[];
  deadline: Date;
  passed: boolean;
  startNext: Date;
  endNext: Date;
}) {
  const [lcId, setLcId] = useState<string | null>(null);
  const [accomodation, setAccomodation] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const revalidator = useRevalidator();
  const setErrorOnly = useSetError();
  const setError = (error: unknown) => {
    setErrorOnly(error);
    revalidator.revalidate();
  };
  const [dialogCallback, setDialogCallback] = useState<
    (() => Promise<void> | void) | null
  >(null);

  return (
    <TransmedProcessSlide
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "var(--gap-medium)",
      }}
    >
      <h3>Stabilește unde vrei să mergi</h3>
      <div>
        {props.registration.confirmed_lc === null
          ? "Locurile la opțiunea ta anterioară s-au epuizat ori sunt pe cale de a se epuiza. Din lista de mai jos, te rugăm să îți alegi locul dorit."
          : "Poți alege centrul unde dorești să participi sau să îl păstrezi pe cel ales anterior."}
      </div>
      <div
        style={{
          marginTop: "var(--gap-medium)",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          gap: "var(--gap-small)",
        }}
      >
        {props.details.map((receivingDetails) => (
          <div
            key={receivingDetails.id}
            className="surface"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "var(--gap-small)",
            }}
          >
            <h4>
              {props.receivings.find(
                (r: TransmedReceiving) => r.lc.id === receivingDetails.receiver
              )?.lc.city ?? "Necunoscut"}
            </h4>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "var(--gap-small)",
              }}
            >
              <button
                disabled={(receivingDetails.accomodation_yes ?? 1) <= 0}
                type="button"
                className={
                  "button primary " +
                  (lcId === receivingDetails.receiver && accomodation
                    ? "outlined"
                    : "text")
                }
                onClick={() => {
                  setLcId(receivingDetails.receiver);
                  setAccomodation(true);
                }}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>Cu cazare</span>
                <b
                  style={{
                    fontWeight: 600,
                    marginTop: "var(--gap-xs)",
                    fontSize: "var(--body-font-size)",
                    color:
                      (receivingDetails.accomodation_yes ?? 1) > 0
                        ? "var(--color-fasmr-blue)"
                        : "var(--color-dark)",
                  }}
                >
                  {receivingDetails.warning_yes && (
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      color="yellow"
                    />
                  )}{" "}
                  {receivingDetails.accomodation_yes ?? (
                    <FontAwesomeIcon icon={faInfinity} />
                  )}
                </b>
              </button>
              <button
                disabled={(receivingDetails.accomodation_no ?? 1) <= 0}
                type="button"
                className={
                  "button primary " +
                  (lcId === receivingDetails.receiver && !accomodation
                    ? "outlined"
                    : "text")
                }
                onClick={() => {
                  setLcId(receivingDetails.receiver);
                  setAccomodation(false);
                }}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>Fără cazare</span>
                <b
                  style={{
                    fontWeight: 600,
                    marginTop: "var(--gap-xs)",
                    fontSize: "var(--body-font-size)",
                    color:
                      (receivingDetails.accomodation_no ?? 1) > 0
                        ? "var(--color-fasmr-blue)"
                        : "var(--color-dark)",
                  }}
                >
                  {receivingDetails.warning_no && (
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      color="yellow"
                    />
                  )}{" "}
                  {receivingDetails.accomodation_no ?? (
                    <FontAwesomeIcon icon={faInfinity} />
                  )}
                </b>
              </button>
            </div>
          </div>
        ))}
      </div>
      {((props.details.find((receiving) => receiving.receiver === lcId)
        ?.warning_yes === true &&
        accomodation) ||
        (props.details.find((receiving) => receiving.receiver === lcId)
          ?.warning_no === true &&
          !accomodation)) && (
        <div
          className="label"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--gap-small)",
            textAlign: "justify",
          }}
        >
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            color="yellow"
            size="xl"
          />
          <div>
            <b>Atenție!</b> Ai selectat o opțiune cu locuri limitate! Există
            șansa să nu prinzi loc aici. În cazul în care participanții cu
            punctaj mai mare vor alege opțiunea aleasă de tine și locurile se
            vor epuiza, va trebui din nou să-ți selectezi centrul, în{" "}
            <b style={{ color: "red" }}>
              {props.startNext.toLocaleDateString("RO-ro")}{" "}
              {props.startNext.toLocaleTimeString("RO-ro")} -{" "}
              {props.endNext.toLocaleTimeString("RO-ro")}
            </b>
            . Nu te teme, însă, nimeni cu punctaj mai mic nu va alege destinația
            înaintea ta! Fii pe fază totuși, întrucât vei pierde locul dacă nu
            îl vei selecta atunci!
          </div>
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "var(--gap-small)",
        }}
      >
        <button
          className="primary button"
          onClick={async () => {
            setError("");
            setLoading(false);

            try {
              if (lcId === null)
                throw new Error(
                  "Trebuie să alegi un centru în care vrei să mergi"
                );
              await new TransmedDistributionService().update.choose(
                props.registration.id,
                lcId,
                accomodation
              );
            } catch (error) {
              setError(error);
            } finally {
              revalidator.revalidate();
              setLoading(false);
            }
          }}
        >
          Confirmă-ți locul
        </button>
        <button
          className="primary button outlined"
          style={{ margin: 0, ...{ "--color": "red" } }}
          onClick={() =>
            setDialogCallback(() => async () => {
              setError("");
              setLoading(false);

              try {
                await new TransmedDistributionService().delete.revoke(
                  props.registration.id
                );
              } catch (error) {
                setError(error);
              } finally {
                revalidator.revalidate();
                setLoading(false);
              }
            })
          }
        >
          Renunță la loc
        </button>
        {props.registration.confirmed_lc !== null && (
          <button
            className="primary button outlined"
            onClick={async () => {
              setError("");
              setLoading(false);

              try {
                await new TransmedDistributionService().update.keep(
                  props.registration.id,
                  props.registration.confirmed_lc!.id,
                  props.registration.confirmed_lc_accomodation
                );
                revalidator.revalidate();
              } catch (error) {
                setError(error);
              } finally {
                setLoading(false);
              }
            }}
          >
            Păstrează-ți locul la {props.registration.confirmed_lc.city}
          </button>
        )}
        {(loading || revalidator.state === "loading") && <CircularProgress />}
      </div>
      <div style={{ color: "red" }}>
        Termen confirmare loc:{" "}
        <b>{props.deadline.toLocaleTimeString("RO-ro")}</b>
      </div>
      <div className="label">
        {props.passed ? (
          <>
            <b style={{ color: "red" }}>Atenție!</b> Aceasta este ultima ta
            șansă de a-ți confirma locul. Dacă vei depăși acest interval orar
            îți vei pierde definitiv șansa de a participa la această ediție
            Transmed.
          </>
        ) : (
          <>
            <b>Atenție!</b> Dacă vei depăși acest interval orar, locul tău va fi
            atribuit unei alte persoane. Dacă vei depăși și intervalul orar
            imediat următor, îți vei pierde definitiv șansa de a participa la
            această ediție Transmed.
          </>
        )}
      </div>
      <InputDialog
        title="Renunță la loc"
        continue_label="Renunță la loc"
        abort_label="Întoarce-te"
        dialogCallback={dialogCallback}
        onClose={() => setDialogCallback(null)}
      >
        Această acțiune este ireversibilă! Vei pierde definitiv șansa de a
        participa la această ediție Transmed.
      </InputDialog>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessChosing;
